import VolcengineAnalytics from "@cndinfo/cube-analytics-sdk"

let param = {}

try {
  const analyticCacheStr = localStorage.getItem("analyticCache")
  if (analyticCacheStr) {
    const analyticCache = JSON.parse(analyticCacheStr)
    const analyticRouterStr = analyticCache.volcengineRouterObjectInfo
    if (analyticRouterStr) {
      const analyticRouter = JSON.parse(analyticRouterStr)
      param = {
        routerObject: {
          history: {
            current: analyticRouter
          }
        }
      }
    }
  } else {
    const uniPluginObject = uni.requireNativePlugin("RangersAppLogUniPluginCN")
    param = {
      uniPluginObject
    }
  }
} catch (e) {}

const analyticsInstance = new VolcengineAnalytics(param)
analyticsInstance.start()
export default analyticsInstance
